import { Projects } from "pages/Projects/Projects";

export default Projects;
